import { useCookieConsent } from "@/contexts/CookieConsentContext";
import { Button } from "./ui/button";
import { X } from "lucide-react";

export const CookieConsentBanner = () => {
  const { showBanner, acceptAll, rejectAll, openModal } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-description"
      className="fixed bottom-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-lg border-t border-border shadow-lg animate-in slide-in-from-bottom duration-200"
      style={{ willChange: "transform" }}
    >
      <div className="container max-w-6xl mx-auto px-4 py-4 sm:py-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <div className="flex-1 pr-8">
            <h2 id="cookie-banner-title" className="text-lg font-semibold mb-2">
              Gestisci il consenso ai cookie
            </h2>
            <p id="cookie-banner-description" className="text-sm text-muted-foreground">
              Usiamo cookie per migliorare la tua esperienza, analizzare il traffico e mostrarti contenuti pertinenti. Scegli tu quali accettare.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
            <Button
              onClick={acceptAll}
              className="w-full sm:w-auto"
              size="lg"
            >
              Accetta tutti
            </Button>
            <Button
              onClick={rejectAll}
              variant="outline"
              className="w-full sm:w-auto"
              size="lg"
            >
              Rifiuta
            </Button>
            <Button
              onClick={openModal}
              variant="ghost"
              className="w-full sm:w-auto underline"
              size="lg"
            >
              Personalizza
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
